export function buildWorkflowTriggerFields(
  dateBased: boolean,
  item: {
    trigger?: string;
    entityType?: string;
    dateField?: string;
    dateTimeDiff?: string | number;
    dateTimeDiff_Unit?: string;
  },
  availableFields: readonly { name: string }[]
) {
  if (!dateBased) {
    if (!item.trigger?.trim()) throw new Error('Select a workflow trigger.');
    return {
      trigger: item.trigger,
      entityType: undefined,
      dateField: undefined,
      beforeOrAfterDateField: undefined,
    };
  }
  if (!['Asset', 'Work', 'TimesheetEntry'].includes(item.entityType ?? ''))
    throw new Error('Select a supported entity type.');
  if (
    !item.dateField ||
    !availableFields.some((field) => field.name === item.dateField)
  )
    throw new Error('Select an available date field for this entity.');
  const amount = Number(item.dateTimeDiff);
  if (!Number.isInteger(amount) || amount <= 0 || amount > 2147483647)
    throw new Error('The date offset must be a positive whole number.');
  if (
    !['mb', 'ma', 'hb', 'ha', 'db', 'da'].includes(item.dateTimeDiff_Unit ?? '')
  )
    throw new Error('Select a valid before/after unit.');
  return {
    trigger: undefined,
    entityType: item.entityType,
    dateField: item.dateField,
    beforeOrAfterDateField: `${amount}|${item.dateTimeDiff_Unit}`,
  };
}

export function buildDateFieldOptions(
  fields: readonly { name: string; label: string }[]
) {
  const unique = [
    ...new Map(fields.map((field) => [field.name, field])).values(),
  ];
  const counts = new Map<string, number>();
  for (const field of unique) {
    const label = field.label.trim() || field.name;
    counts.set(label, (counts.get(label) ?? 0) + 1);
  }
  return unique.map((field) => {
    const label = field.label.trim() || field.name;
    return {
      key: field.name,
      value: (counts.get(label) ?? 0) > 1 ? `${label} [${field.name}]` : label,
    };
  });
}
